import { put, SagaGenerator, takeLatest } from "typed-redux-saga";
import { Action, AnyAction } from "typescript-fsa";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Events } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/store";
import { TreeEngineActions } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";

/**
 * Saga die auf das Event "close_modal" hört um dann den Textbausteinbaum zu schließen
 */
export function* closeTree(): SagaGenerator<void> {
	yield* takeLatest((action: AnyAction) => {
		return (
			TreeEngineActions.event.match(action) &&
			Events.onEventButtonClicked.match(action.payload.engineAction) &&
			["close_modal"].includes(action.payload.engineAction.payload.button.event)
		);
	}, handle);
}

type EventAction = Action<TreeEngineActions.EventPayload<Action<Events.NodeEventButtonClickedPayload>>>;
function* handle(action: EventAction): SagaGenerator<void> {
	const { activityId } = action.payload;
	yield* put(
		ActivityActions.cancel({
			activityId
		})
	);
}
